import { useMemo, useState } from 'react';
import {
	MaterialReactTable,
	useMaterialReactTable,
	MRT_TableContainer,
	MRT_TableHeadCellFilterContainer,
	MRT_GlobalFilterTextField,
	MRT_ToggleFiltersButton,
	MRT_FilterTextField,
} from 'material-react-table';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import { useNavigate } from 'react-router-dom/dist';
import {
	Badge,
	Button,
	Chip,
	IconButton,
	Box,
	Stack,
	Tooltip,
	Paper,
	useMediaQuery,
	Typography,
} from '@mui/material';
import { Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import DateCell from './common/DateCell';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import { capitalizeFirstLetter, priorityColor } from '../helper/utils';
import WorkIcon from '@mui/icons-material/Work';

const CogenTable = props => {
	const isMobile = useMediaQuery('(max-width: 1000px)');
	const navigate = useNavigate();
	const profile = useSelector(state => state.auth.profile);

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const notificationHandler = id => {
		navigate(`/notifications/${id}`);
	};

	function ActionsHandler({ cell, dataType }) {
		const row = cell.row.original;

		return (
			<>
				{dataType === 'Publish' && (
					<Stack direction={'row'} gap={1}>
						<Badge
							variant='standard'
							color={row?.notifications_count > 0 ? 'error' : 'default'}
							badgeContent={
								row?.notifications_count > 0 ? (
									<span style={{ fontSize: '10px' }}>
										{row.notifications_count}
									</span>
								) : null
							}
						>
							<Button
								variant='contained'
								size='small'
								sx={{ fontSize: '10px' }}
								onClick={() => notificationHandler(row.id)}
							>
								Notification
							</Button>
						</Badge>
						<Button
							sx={{ fontSize: '12px' }}
							size='small'
							variant='contained'
							color='success'
							onClick={() => props.pauseJobHandler(row.id)}
						>
							Pause Job
						</Button>
						<Button
							sx={{ fontSize: '12px' }}
							variant='contained'
							size='small'
							color='error'
							onClick={() => props.cancelJobHandler(row.id)}
						>
							Cancel Job
						</Button>
						<Button
							sx={{ fontSize: '12px' }}
							variant='contained'
							color='success'
							size='small'
							onClick={() => {
								navigate(`job/${row.id}/applicants`);
							}}
						>
							Applicants
						</Button>{' '}
						{row?.members?.length ? (
							<Button
								sx={{ fontSize: '12px' }}
								size='small'
								variant='contained'
								onClick={() => props.filledJobHandler(row.id)}
							>
								Short-List
							</Button>
						) : (
							''
						)}
					</Stack>
				)}
				{dataType === 'Pause' && (
					<Row style={{ marginLeft: '0px', justifyContent: 'normal' }}>
						<Button
							size='small'
							variant='contained'
							color='success'
							onClick={() => props.publishPausedJobHandler(row)}
						>
							Resume Job
						</Button>
					</Row>
				)}
				{dataType === 'Draft' && (
					<Stack direction={'row'} gap={1}>
						{profile.user.is_subscribed === 1 ? (
							<Button
								size='small'
								variant='contained'
								color='success'
								onClick={() => {
									props.draftConfirmation(row.id);
								}}
							>
								Publish Job
							</Button>
						) : null}
						<Button
							size='small'
							variant='contained'
							onClick={() => navigate(`${row.id}/edit-job`)}
						>
							Edit Job
						</Button>
					</Stack>
				)}
			</>
		);
	}

	const rowEvents = (e, row, rowIndex) => {
		if (
			e.target.tagName === 'TD' &&
			props.dataType != 'Publish' &&
			props.dataType != 'archived'
		)
			navigate(`${row.original.id}/edit-job`);
		if (e.target.tagName === 'TD' && props.dataType == 'Publish')
			navigate({
				pathname: `/job/${row.original.id}/applicants`,
				state: { pageNumber: 1, tab: 1 },
			});
		if (e.target.tagName === 'TD' && props.dataType == 'Pause')
			navigate({
				pathname: `/job/${row.original.id}/pause`,
				state: { pageNumber: 1, tab: 1 },
			});
		if (e.target.tagName === 'TD' && props.dataType == 'archived')
			navigate({
				pathname: `/job/${row.original.id}/archived-job`,
				state: { pageNumber: 1, tab: 1 },
			});
	};

	const TableColumns = [
		{
			header: 'Job ID',
			accessorKey: 'id',
			enableSorting: false,
			// enableGlobalFilter: false,
			enableColumnActions: false,
			size: 10,
			// Cell: ({ cell }) => (
			// 	<Typography sx={{ fontWeight: 'bold' }} variant='subtitle2'>
			// 		{cell.row.original.id}
			// 	</Typography>
			// ),
		},
		{
			header: 'Project ID',
			accessorKey: 'job_id',
			enableSorting: false,
			enableGlobalFilter: false,

			enableColumnActions: false,
			size: 10,
			// Cell: ({ cell }) => (
			// 	<Typography sx={{ fontWeight: 'bold' }} variant='subtitle2'>
			// 		{cell.row.original.job_id}
			// 	</Typography>
			// ),
		},

		{
			header: 'Priority',
			accessorKey: 'priority',
			enableSorting: false,
			enableColumnFilterModes: false,
			enableColumnFilters: false,
			enableFilters: false,

			enableColumnFilter: false,
			enableGlobalFilter: false,
			enableColumnActions: false,
			showColumnFilters: false,
			Cell: ({ cell }) => (
				<Typography
					sx={{ fontWeight: '900', fontSize: '14px' }}
					variant='subtitle2'
					// color={priorityColor(cell.row.original.priority)}
				>
					{capitalizeFirstLetter(cell.row.original.priority)}
				</Typography>
			),
			size: 10,
		},
		{
			header: 'Date Posted',
			accessorKey: 'created_at',
			enableColumnFilter: false,
			enableSorting: false,
			enableGlobalFilter: false,
			enableColumnActions: false,
			Cell: ({ cell }) => 
			{
				const originalDate = new Date(cell.row.original.created_at);
				const formattedDate = `${originalDate.getFullYear()}-${(
					originalDate.getMonth() + 1
				)
					.toString()
					.padStart(2, '0')}-${originalDate
					.getDate()
					.toString()
					.padStart(2, '0')}`;

				return (
					<div style={{ width: 10, whiteSpace: 'nowrap' }}>
						<Box component='div' sx={{ textOverflow: 'ellipsis' }}>
							{formattedDate}
						</Box>
					</div>
				);
			},
			size: 10,
		},
		{
			header: 'Title',
			accessorKey: 'title',
			enableSorting: false,
			enableColumnFilter: false,
			enableColumnActions: false,

			enableColumnFilterModes: false,
			enableColumnFilters: false,
			enableFilters: false,
			enableGlobalFilter: false,

			showColumnFilters: false,
			size: 300,
			Cell: ({ cell }) => (
				<Typography
					sx={{ fontWeight: '900', fontSize: '14px' }}
					variant='subtitle2'
				>
					{cell.row.original.title}
				</Typography>
			),
		},
		{
			header: 'Start Date',
			accessorKey: 'start_date',
			enableSorting: false,
			enableColumnActions: false,
			enableColumnFilter: false,
			enableGlobalFilter: false,
			Cell: ({ cell }) => <DateCell date={cell.row.original.start_date} />,
			size: 10,
		},
		{
			header: 'End Date',
			accessorKey: 'end_date',
			enableSorting: false,
			enableColumnFilter: false,
			enableGlobalFilter: false,
			enableColumnActions: false,
			Cell: ({ cell }) => <DateCell date={cell.row.original.end_date} />,
			size: 10,
		},
		{
			header: 'Job Actions',
			accessorKey: 'name',
			enableGlobalFilter: false,
			enableColumnActions: false,
			enableSorting: false,
			enableColumnFilter: false,
			Cell: ({ cell }) => (
				<ActionsHandler cell={cell} dataType={props.dataType} />
			),
		},
	];

	const ArchivedColumns = [
		{
			header: 'Title',
			accessorKey: 'title',
			size: 140,
			enableSorting: false,
			enableColumnFilter: false,
			enableColumnActions: false,
			Cell: ({ cell }) => (
				<div style={{ width: 140, whiteSpace: 'nowrap' }}>
					<Box component='div' sx={{ textOverflow: 'ellipsis', fontWeight:'bold' }}>
						{cell.row.original.title}
					</Box>
				</div>
			),
		},
		{
			header: 'Priority',
			accessorKey: 'priority',
			size: 130,
			enableSorting: false,
			enableColumnFilter: false,
			enableColumnActions: false,
			Cell: ({ cell }) => (
				<div style={{ width: 130, whiteSpace: 'nowrap' }}>
					<Box component='div' sx={{ textOverflow: 'ellipsis', fontWeight:'bold' }}>
						{cell.row.original.priority}
					</Box>
				</div>
			),
		},
		{
			header: 'Start Date',
			accessorKey: 'start_date',
			size: 130,
			enableSorting: false,
			enableColumnFilter: false,
			enableColumnActions: false,
			Cell: ({ cell }) => (
				<div style={{ width: 130, whiteSpace: 'nowrap' }}>
					<Box component='div' sx={{ textOverflow: 'ellipsis', fontWeight:'bold' }}>
						{cell.row.original.start_date}
					</Box>
				</div>
			),
		},
		{
			header: 'End Date',
			accessorKey: 'end_date',
			size: 130,
			enableSorting: false,
			enableColumnFilter: false,
			enableColumnActions: false,
			Cell: ({ cell }) => (
				<div style={{ width: 130, whiteSpace: 'nowrap' }}>
					<Box component='div' sx={{ textOverflow: 'ellipsis', fontWeight:'bold' }}>
						{cell.row.original.end_date}
					</Box>
				</div>
			),
		},
		{
			header: 'Description',
			accessorKey: 'description',
			size: 340,
			enableSorting: false,
			enableColumnFilter: false,
			enableColumnActions: false,
		},
		{
			header: 'Date Posted',
			accessorKey: 'created_at',
			size: 130,
			enableSorting: false,
			enableColumnFilter: false,
			enableColumnActions: false,
			Cell: ({ cell }) => 
			{
				const originalDate = new Date(cell.row.original.created_at);
				const formattedDate = `${originalDate.getFullYear()}-${(
					originalDate.getMonth() + 1
				)
					.toString()
					.padStart(2, '0')}-${originalDate
					.getDate()
					.toString()
					.padStart(2, '0')}`;

				return (
					<div style={{ width: 130, whiteSpace: 'nowrap' }}>
						<Box component='div' sx={{ textOverflow: 'ellipsis' }}>
							{formattedDate}
						</Box>
					</div>
				);
			},
		},

		{
			header: 'Job ID',
			accessorKey: 'id',
			size: 130,
			enableSorting: false,
			enableColumnFilter: false,
			enableColumnActions: false,
		},

		{
			header: 'Status',
			accessorKey: 'status',
			enableSorting: false,
			enableColumnFilter: false,
			enableColumnActions: false,
			Cell: ({ cell }) => {
				return (
					<>
						{cell.row.original.is_filled === 1 && (
							<Button color='success' size='small' variant='contained'>
								Filled
							</Button>
						)}
						{cell.row.original.is_cancel === 1 && (
							<Button color='error' size='small' variant='contained'>
								Canceled
							</Button>
						)}
						{/* {cell.row.original.is_paused && (
							<Button color='error' size='small' variant='contained'>
								Paused
							</Button>
						)} */}
					</>
				);
			},
		},
	];

	//should be memoized or stable
	const columns = useMemo(
		() => (props.dataType === 'archived' ? ArchivedColumns : TableColumns),
		[]
	);

	const table = useMaterialReactTable({
		columns: columns,
		data: props.data,

		enableFacetedValues: true,
		initialState: { showGlobalFilter: true },
		paginationDisplayMode: 'pages',
		positionToolbarAlertBanner: 'bottom',
		muiSearchTextFieldProps: {
			size: 'small',
			variant: 'outlined',
		},

		muiPaginationProps: {
			showRowsPerPage: false,
			shape: 'rounded',
		},
		paginationDisplayMode: 'pages', //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
		state: {
			// isLoading: props.isLoading,
			// showProgressBars: props.isLoading,
			// showLoadingOverlay: false,
		},
		enableTopToolbar: true,
		muiSkeletonProps: {
			animation: 'wave',
		},
		muiLinearProgressProps: {
			variant: 'indeterminate',
			color: 'primary',
		},

		positionActionsColumn: 'last',
		renderRowActions: ({ row }) => (
			<>
				{props?.dataType === 'Publish' && (
					<Stack direction={'row'} gap={2}>
						<Badge variant='dot' color='error'>
							<Button
								onClick={() => notificationHandler(row.id)}
								variant='contained'
								size='small'
								sx={{ fontSize: '12px' }}
							>
								Notification
							</Button>
						</Badge>

						<Button
							onClick={() => props.pauseJobHandler(row.id)}
							sx={{ fontSize: '12px' }}
							size='small'
							variant='contained'
							color='success'
						>
							Pause Job
						</Button>

						<Button
							onClick={() => props.cancelJobHandler(row.id)}
							sx={{ fontSize: '12px' }}
							variant='contained'
							size='small'
							color='error'
						>
							Cancel Job
						</Button>

						<Button
							onClick={() => {
								navigate(`job/${row.id}/applicants`);
							}}
							sx={{ fontSize: '12px' }}
							variant='contained'
							size='small'
						>
							Applicants
						</Button>

						{row?.members?.length ? (
							<Button
								onClick={() => props.filledJobHandler(row.id)}
								sx={{ fontSize: '12px' }}
								size='small'
								variant='contained'
							>
								Job Filled
							</Button>
						) : (
							''
						)}
					</Stack>
				)}
			</>
		),
		muiTableBodyRowProps: ({ row }) => ({
			onClick: event => {
				console.info(event, row.id);
				rowEvents(event, row);
			},
			sx: {
				cursor: 'pointer', //you might want to change the cursor too when adding an onClick
			},
		}),
		globalFilterFn: 'equals',

		renderTopToolbar: ({ table }) => {
			return (
				<Box
					sx={theme => ({
						// backgroundColor: lighten(theme.palette.background.default, 0.05),
						display: 'flex',
						gap: '1.5rem',
						p: '8px',
					})}
				>
					<Box>
						<Box sx={{ display: 'flex', gap: '0.5rem' }}>
							<Button
								style={{
									backgroundColor: '#e17739',
									borderRadius: '10px',
									height: '40px',
									width: '220px',
								}}
								variant='contained'
								onClick={() => navigate('/jobs/create')}
							>
								<AddCircleOutlineIcon /> Submit new job
							</Button>
						</Box>
					</Box>
					<Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
						<MRT_GlobalFilterTextField
							placeholder='Serch by job id'
							table={table}
						/>
					</Box>
				</Box>
			);
		},
	});

	return <MaterialReactTable table={table} />;
};

export default CogenTable;
